import React from "react";

import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { IconButton } from "@mui/material";
import { TextBox } from "@progress/kendo-react-inputs";
import { useTranslation } from "react-i18next";

const TextFilterCell = (props) => {
  const { field } = props;
  const [value, setValue] = React.useState(props.value || props.defaultItem);
  let hasValue = (value) => Boolean(value && value !== props.defaultItem);
  const { t } = useTranslation();
  const onChange = (event) => {
    const searchValue = event.target.value;
    setValue(searchValue);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      props.onChange({
        value: value,
        operator: "contains",
        field: field,
      });
    }
  };
  const onClearButtonClick = (event) => {
    event.preventDefault();
    props.onChange({
      value: "",
      operator: "",
      syntheticEvent: event,
    });
  };
  return (
    <div className="k-filtercell">
      <TextBox
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        className="k-textbox"
        placeholder={t("press_enter")}
      />
      <IconButton
        disabled={!hasValue(props.value)}
        onClick={onClearButtonClick}
      >
        <FilterAltOffIcon />
      </IconButton>
    </div>
  );
};

export default TextFilterCell;
